import Cookies from "js-cookie";
import config from "lib/config";

/**
 * Replaces parameters in url noted by :parameter by the equivalent property in the parameters object
 * e.g: urlFormat('v1/api/:id' ,{ id: 1 }) returns 'v1/api/1'
 * @param {string} url
 * @param {object} parameters
 * @returns url with :params replaced by values in parameter
 */
export const urlFormat = (url, parameters) => {
  if (parameters !== undefined) {
    //replace :parameter with value defined in object.
    url = url.replace(/:([a-zA-Z0-9_]+)/g, function (_, v) {
      return encodeURIComponent(parameters[v] || "");
    });
  }

  url = config.apiUrl + url.replace(/^\//, "");
  return url;
};

export const getHeaders = (bodyAsJson) => {
  refreshTokenIfHalfLifetimeHasPassed();
  const headers = {
    ...getAcceptLanguageHeader(),
  };
  if (bodyAsJson) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
};

const getAcceptLanguageHeader = () => {
  return {
    "Accept-Language": config.culture,
  };
};

/**
 * Parses the text as JSON if possible, otherwise returns the text
 * @param {string} text
 * @returns {object|string}
 */
export const getJsonOrDefault = (text) => {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

/**
 * Refreshes the api session(apiToken cookie), refreshing the lifelength to the value set in configuration files
 */
export const refreshApiCookie = async () => {
  const headers = { ...getAcceptLanguageHeader() };

  const baseUrl = config.apiUrl || "";
  fetch(`${baseUrl}v1/users/refreshToken`, {
    method: "POST",
    headers,
    body: "",
  }).catch(() => {
    logOut();
  });
};

/**
 * Refreshes the portal session(lp2004b cookie), refreshing the lifelength to the value set in configuration files
 */
export const refreshPortalCookie = async () => {
  const headers = { ...getAcceptLanguageHeader() };
  const IsInAdministration = config.urlRoot?.toLowerCase() === "/luvitadmin";
  if (IsInAdministration) {
    return;
  }
  const portalUrl = config.urlRoot || "/luvitportal/";
  await fetch(
    `${
      window.location.origin
    }${portalUrl}authenticatedkeepalive.aspx?time=${new Date().getTime()}`,
    {
      method: "GET",
      headers,
    },
  ).catch(() => {
    logOut();
  });
};

export const refreshContextToken = async () => {
  const headers = { ...getAcceptLanguageHeader() };
  const portalUrl = config.urlRoot || "/luvitportal/";
  await fetch(`${portalUrl}settoken.aspx`, { method: "GET", headers });
};

export const logOut = () => {
  window.location.href = `${config.urlRoot}/logout`;
};

export const refreshTokenIfHalfLifetimeHasPassed = () => {
  const sessionExpiry = Cookies.get("sessionExpiration");
  const sessionTimeout = Cookies.get("sessionTimeout") || 60;
  if (!sessionExpiry) {
    logOut();
    return;
  }

  const expirationDateTime = new Date(sessionExpiry);
  const now = new Date();
  if (expirationDateTime - now < 0) {
    logOut();
    return;
  }

  if (expirationDateTime - now < (sessionTimeout / 2) * 60 * 1000) {
    refreshApiCookie();
    refreshPortalCookie();
    return;
  }
};
